import { useAppSelector } from 'store/hooks';
import { selectLocalMuteEnabled } from 'features/room/roomSlice';
import { selectIsUserLocallyMuted } from 'features/local-mute/localMuteSlice';
import { UserId } from 'features/users/types';

export const useIsLocallyMuted = (userId: UserId): boolean => {
  const enabled = useAppSelector(selectLocalMuteEnabled);
  const isMuted = useAppSelector((state) => selectIsUserLocallyMuted(state, userId));

  return enabled && isMuted;
};
